import { render, staticRenderFns } from "./WorkflowBox.vue?vue&type=template&id=6139d7b4&scoped=true&"
import script from "./WorkflowBox.vue?vue&type=script&lang=js&"
export * from "./WorkflowBox.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowBox.vue?vue&type=style&index=0&id=6139d7b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6139d7b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Coding/farmerspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VImg,VLayout,VProgressCircular})
